import TextWrapper from './TextWrapper';
import { type CSSProperties, useMemo } from 'react';
import { GradualSpacing } from '../../../effects/GradualSpacing';

export default function ListItem({ title, details, size, offset = 0 }: {
    title: string,
    details?: [string, string],
    size: 'small' | 'normal',
    offset?: number,
}) {
    const info = useMemo(() => {
        if (!details?.[0] && details?.[1]) {
            return [details?.[1]];
        }

        return details;
    }, [details]);

    const largeFont = {
        fontSize: '3.91vh', // 75
        lineHeight: '0.93em',
        letterSpacing: '-0.04em',
    };

    const detailFont: CSSProperties = size === 'normal' ? largeFont : {
        fontSize: '2.19vh', // 42
        lineHeight: '0.93em',
        letterSpacing: '-0.02em',
        textTransform: 'uppercase',
    };

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '1.04vh', // 20
                ...largeFont,
            }}
        >
            <TextWrapper
                style={{
                    position: 'relative',
                    textTransform: 'uppercase',
                }}
            >
                <GradualSpacing
                    text={title}
                    offset={offset + .2}
                />
            </TextWrapper>
            <TextWrapper
                style={{
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'space-between',
                    fontWeight: 400,
                    ...detailFont,
                }}
            >
                <div>
                    <GradualSpacing
                        text={info?.[0]}
                        offset={offset + .4}
                    />
                </div>
                <div style={{ textTransform: 'none' }}>
                    <GradualSpacing
                        text={info?.[1]}
                        offset={offset + .6}
                    />
                </div>
            </TextWrapper>
        </div>
    );
}
